import React from 'react';
import { connect } from 'react-redux';
import TemplateOptions from './TemplateOptions';
import MenuBlock from '../Common/MenuBlock';
import {
  setTemplateDayTabSelect,
  changeTemplateGeneratorDishPortion,
  changeTemplateGeneratorDish,
  addTemplateGeneratorDish,
  deleteTemplateGeneratorDish,
  changeTemplateGeneratorMealTime,
  changeTemplateGeneratorDishTime,
  setMenuTemplateGenerator,
  changeTemplateMenuDays,
  changeTemplateName,
  selectTemplateTagsFilters,
  setChosenTemplateEatings,
  setTemplateParametersCategories,
  changeTemplateDescription,
} from '../../actions/templateGenerator';
import { getTemplate } from '../../actions/template';
import { toggleChangeTheSameDays, transformMenuStructure } from '../../actions/menu';
import FoodNavigationsScreen from '../Common/FoodNavigatonsScreen';
import {
  SMALLER_DAY_VIOLATION,
  BIGGEST_DAY_VIOLATION,
  NONE_DAY_VIOLATION,
  PERCENTAGE_MAX_CALORIES,
  DEFAULT_ACTIVITY_COEFFICIENT,
  CATEGORY_INGREDIENTS,
  EATING_TAGS,
  TEMPLATE_PARAMETERS_TAG,
} from '../../constants/appConstants';

const TemplateGenerator = ({
  templateTabSelected,
  setTemplateDayTabSelect,
  countTemplateDays,
  menuTemplateGenerator,
  changeTemplateGeneratorDishPortion,
  changeTemplateGeneratorDish,
  addTemplateGeneratorDish,
  deleteTemplateGeneratorDish,
  changeTemplateGeneratorMealTime,
  changeTemplateGeneratorDishTime,
  toggleChangeTheSameDays,
  isChangeTheSameDays,
  templateSameDaysCount,
  setMenuTemplateGenerator,
  getTemplate,
  match,
  template,
  changeTemplateMenuDays,
  changeTemplateName,
  selectTemplateTagsFilters,
  setChosenTemplateEatings,
  setTemplateParametersCategories,
  changeTemplateDescription,
  sameDaysCount,
}) => {
  const [daysViolations, setDaysViolations] = React.useState([]);
  const [maxCalories, setMaxCalories] = React.useState(0);
  const activityCoefficient = DEFAULT_ACTIVITY_COEFFICIENT;
  const countTotalFitValuesByDay = React.useCallback((data, valueName) => {
    let totalFitValue = 0;
    data.forEach((eating) => {
      eating.meals.forEach((dishData) => {
        totalFitValue += dishData[`counted_${valueName}`];
      });
    });
    return totalFitValue.toFixed(2);
  });

  const calculatePercentageOfDifferenceInValues = (currentValue, maxValue) => {
    const percentage = ((currentValue - maxValue) * 100) / maxValue;
    return Math.abs(Math.round(percentage));
  };

  const getDayWithExcessCalories = React.useCallback(
    (menu) => {
      const dayViolations = [];

      menu.map((mealsDataForDay) => {
        const totalCalories = countTotalFitValuesByDay(mealsDataForDay, 'calories');
        if (!maxCalories || +totalCalories === 0) {
          dayViolations.push({ violations: NONE_DAY_VIOLATION });
        } else if (totalCalories < maxCalories / activityCoefficient) {
          dayViolations.push({ violations: SMALLER_DAY_VIOLATION });
          return dayViolations;
        } else if (
          totalCalories > maxCalories * 0.9 && // norm calories - 10%
          calculatePercentageOfDifferenceInValues(totalCalories, maxCalories * 0.9) >=
            PERCENTAGE_MAX_CALORIES
        ) {
          dayViolations.push({ violations: BIGGEST_DAY_VIOLATION });
          return dayViolations;
        } else {
          dayViolations.push({ violations: NONE_DAY_VIOLATION });
        }
        return dayViolations;
      });
      setDaysViolations(dayViolations);
    },
    [menuTemplateGenerator, maxCalories],
  );

  React.useEffect(() => {
    getDayWithExcessCalories(menuTemplateGenerator);
  }, [menuTemplateGenerator, maxCalories]);

  React.useEffect(() => {
    const templateId = match && match.params && match.params.id;
    if (templateId) getTemplate(templateId);
  }, []);
  React.useEffect(() => {
    if (template) {
      const transformedMenu = transformMenuStructure(template.menu, sameDaysCount);
      setMenuTemplateGenerator(transformedMenu);
      changeTemplateMenuDays(template.days);
      changeTemplateName(template.name);
      changeTemplateDescription(template.description);

      const categoryTagIds = [];
      const eatingTagIds = [];
      const paramTagIds = [];
      template.filters.forEach((tag) => {
        if (tag.category_id === CATEGORY_INGREDIENTS) categoryTagIds.push(tag.tag_id);
        if (tag.category_id === EATING_TAGS) eatingTagIds.push(tag.tag_id);
        if (tag.category_id === TEMPLATE_PARAMETERS_TAG) paramTagIds.push(tag.tag_id);
      });
      selectTemplateTagsFilters(categoryTagIds);
      setChosenTemplateEatings(eatingTagIds);
      setTemplateParametersCategories(paramTagIds);
    }
  }, [template]);

  return (
    <React.Fragment>
      <FoodNavigationsScreen />
      <TemplateOptions setMaxCalories={setMaxCalories} maxCalories={maxCalories} />
      <MenuBlock
        daysCount={countTemplateDays}
        setActiveDayTab={setTemplateDayTabSelect}
        activeDayTab={templateTabSelected}
        menu={menuTemplateGenerator}
        changeDishPortion={changeTemplateGeneratorDishPortion}
        changeDish={changeTemplateGeneratorDish}
        addDish={addTemplateGeneratorDish}
        deleteDish={deleteTemplateGeneratorDish}
        changeMealTime={changeTemplateGeneratorMealTime}
        changeDishTime={changeTemplateGeneratorDishTime}
        isChangeTheSameDays={isChangeTheSameDays}
        toggleChangeTheSameDays={toggleChangeTheSameDays}
        sameDaysCount={templateSameDaysCount}
        setMenuMenuGenerator={setMenuTemplateGenerator}
        countTotalFitValuesByDay={countTotalFitValuesByDay}
        daysViolations={daysViolations}
        isCreateTemplate
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const {
    templateTabSelected,
    countTemplateDays,
    menuTemplateGenerator,
    templateSameDaysCount,
  } = state.templateGenerator;
  const { template } = state.template;
  const { isChangeTheSameDays, sameDaysCount } = state.menu;
  return {
    templateTabSelected,
    countTemplateDays,
    menuTemplateGenerator,
    isChangeTheSameDays,
    templateSameDaysCount,
    template,
    sameDaysCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTemplateDayTabSelect: (number) => dispatch(setTemplateDayTabSelect(number)),
    changeTemplateGeneratorDishPortion: (dishId, value) => {
      dispatch(changeTemplateGeneratorDishPortion(dishId, value));
    },
    changeTemplateGeneratorDish: (positionDishId, newDishId) => {
      dispatch(changeTemplateGeneratorDish(positionDishId, newDishId));
    },
    addTemplateGeneratorDish: (dayNumber, mealType) => {
      dispatch(addTemplateGeneratorDish(dayNumber, mealType));
    },
    deleteTemplateGeneratorDish: (positionDishId) => {
      dispatch(deleteTemplateGeneratorDish(positionDishId));
    },
    changeTemplateGeneratorMealTime: (dayIndex, type, timeValue) => {
      dispatch(changeTemplateGeneratorMealTime(dayIndex, type, timeValue));
    },
    changeTemplateGeneratorDishTime: (positionDishId, timeValue) => {
      dispatch(changeTemplateGeneratorDishTime(positionDishId, timeValue));
    },
    toggleChangeTheSameDays: () => {
      dispatch(toggleChangeTheSameDays());
    },
    setMenuTemplateGenerator: (menu) => {
      dispatch(setMenuTemplateGenerator(menu));
    },
    getTemplate: (id) => {
      dispatch(getTemplate(id));
    },
    changeTemplateMenuDays: (daysCount) => {
      dispatch(changeTemplateMenuDays(daysCount));
    },
    changeTemplateName: (templateName) => {
      dispatch(changeTemplateName(templateName));
    },
    changeTemplateDescription: (templateDescription) => {
      dispatch(changeTemplateDescription(templateDescription));
    },
    selectTemplateTagsFilters: (tags) => {
      dispatch(selectTemplateTagsFilters(tags));
    },
    setChosenTemplateEatings: (tagsIds) => {
      dispatch(setChosenTemplateEatings(tagsIds));
    },
    setTemplateParametersCategories: (templateParamTagsFilters) => {
      dispatch(setTemplateParametersCategories(templateParamTagsFilters));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateGenerator);



// WEBPACK FOOTER //
// ./src/Components/TemplateGenerator/index.js